/** Central error shapes mapped from Keitaro-style error bodies (Plan 2A §1 "Error bodies"). */

export class ApiError extends Error {
  status: number
  /** 422 field -> message[] map, when the server answered a validation error. */
  fields?: Record<string, string[]>
  /** Raw body text for 404 plain-text bodies. */
  raw?: string

  constructor(
    message: string,
    status: number,
    opts?: { fields?: Record<string, string[]>; raw?: string },
  ) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.fields = opts?.fields
    this.raw = opts?.raw
  }
}

export class UnauthorizedError extends ApiError {
  constructor(message = 'Unauthorized') {
    super(message, 401)
    this.name = 'UnauthorizedError'
  }
}

/** True when a parsed JSON body looks like a Keitaro 422 field-error map (`{"field": ["msg"]}`). */
export function isFieldErrorBody(body: unknown): body is Record<string, string[]> {
  if (!body || typeof body !== 'object' || Array.isArray(body)) return false
  return Object.values(body as Record<string, unknown>).every(
    (v) => Array.isArray(v) && v.every((x) => typeof x === 'string'),
  )
}
